<template>
  <v-container class="gray-wrapper">
     <div class="img_container">
      <img class="update_img" src="../assets/img/pay_img.png" />
      <h2 class="message_title">404 ERROR</h2>
      <div class="message_caption">
        죄송합니다.
      </div>
      <div class="message_caption">
        존재하지 않는 주소를 입력하셨거나,
      </div>
      <div class="message_caption">
        요청하신 페이지의 주소가
        변경, 삭제되어 찾을 수 없습니다.
      </div>
      <v-btn text color="primary" to="/home">홈으로 이동</v-btn>
    </div>   
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped>
.img_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  background-color: #f1f2f5;
}
.message_title {
  font-family: roboto;
  font-size: 1.3rem;
  color: #121212;
  text-align: center;
}
.message_caption {
  font-family: roboto;
  font-size: 1rem;
  color: #121212;
  text-align: center;
}
.top1 {
  margin-top: 2rem;
}
.update_img {
  margin: 8rem 0rem 2rem 0rem;
  width: 50%;
  max-width: 20rem;
}
</style>
